import { useCallback } from 'react'
import { useMutate } from 'restful-react'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import { useNotifications } from '@trileuco/triskel-react-ui/components/ui/notifications'
import { useErrorNotification } from 'modules/bookables/notifications'

const useNewComment = (bookingId, text) => {
  const { mutate, ...rest } = useMutate({
    path: `/bookings/${bookingId}/comments`,
    verb: 'POST',
    text
  })

  const { notifyError } = useErrorNotification()
  const {
    notify,
    statusTypes: { LOADING, SUCCESS }
  } = useNotifications()

  const { msg } = useIntl({
    scope: 'balaena.api.useNewComment',
    ignoreGlobalScope: true
  })

  const notifyNewComment = useCallback(
    (notification) => {
      notify({
        id: 'COMMENT',
        title: msg({ id: notification.status }),
        ...notification
      })
    },
    [msg, notify]
  )

  const newComment = useCallback(
    (params) => {
      notifyNewComment({ status: LOADING })
      return mutate(params)
        .then((result) => {
          notifyNewComment({ status: SUCCESS })
          return result
        })
        .catch((error) => {
          notifyError({
            id: 'COMMENT',
            title: msg({ id: 'error' }),
            error
          })
          throw error
        })
    },
    [notifyNewComment, LOADING, mutate, SUCCESS, notifyError, msg]
  )
  return {
    newComment,
    ...rest
  }
}

export default useNewComment
